"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Seach = function Seach() {
  return _react2.default.createElement(
    "g",
    { id: "search" },
    _react2.default.createElement("path", {
      d: "M377.81,334.63 L370.61,341.83 L343.67,314.89 C371.588646,280.557427 386.820699,237.651282 386.8,193.4 C386.8,86.76 300,0 193.4,0 C86.8,0 0,86.76 0,193.4 C0,300.04 86.76,386.8 193.4,386.8 C237.649921,386.822707 280.555668,371.594328 314.89,343.68 L341.83,370.62 L334.63,377.82 L456.82,500 L500,456.82 L377.81,334.63 Z M193.4,325.73 C120.4,325.73 61.07,266.37 61.07,193.4 C61.07,120.43 120.44,61.07 193.4,61.07 C266.36,61.07 325.73,120.44 325.73,193.4 C325.73,266.36 266.36,325.73 193.4,325.73 L193.4,325.73 Z",
      id: "Shape"
    })
  );
};

exports.default = Seach;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Search.js
// module id = 2985
// module chunks = 4